import React from 'react';
import { useNavigate } from 'react-router-dom';

import Stepper from '@components/parts/Stepper';
import { Box, Button, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { FacilityState } from '@atom/FacilityState';
import { ReservationState } from '../../../atom/ReservationState';
import { IS_DISP_FEE } from '../../../config/applicationConfig';
import PageBase from '../PageBase';

const TemporaryReservationCompletePage = () => {
  const navigate = useNavigate();
  const reservation = useRecoilValue(ReservationState);
  const facility = useRecoilValue(FacilityState);
  const resetReservationState = useResetRecoilState(ReservationState);

  return (
    <PageBase title="仮予約完了" isButton={false}>
      <Box sx={{ mr: 1, ml: 1 }}>
        <Stepper activeStep={3} />
        <Grid container spacing={2}>
          <Grid xs={12} m={1}>
            <Typography variant="subtitle1" sx={{ textAlign: 'right' }}>
              申し込み番号：{reservation.reservationId}
            </Typography>
          </Grid>
          <Grid xs={12}>
            <Box sx={{ mt: 1, mb: 2 }}>
              <Typography>
                仮予約完了メールを送信しました。
                <br />
                申請期限までに使用許可申請を行ってください。
              </Typography>
              <Typography sx={{ color: 'red', fontWeight: 'bold' }}>
                ※期限内に申請が行われなかった場合は、自動的にキャンセルになります。
              </Typography>
            </Box>
            {/* 現在は常に金額非表示だが、今後表示が必要になった際に戻せるように残しておく */}
            {IS_DISP_FEE &&
              <Card sx={{ height: 'auto', backgroundColor: '#EEF1F4', p: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>施設利用料</Typography>
                  <Typography>{reservation.facilityFee}円</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>備品・設備</Typography>
                  <Typography>{reservation.selectedEquipmentTotal}円</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography>合計金額(税込)</Typography>
                  <Typography variant="h5">{reservation.totalFee}円</Typography>
                </Box>
              </Card>
            }
            <Card sx={{ height: 'auto', backgroundColor: '#EEF1F4', p: 1, mt: 2, mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography>申請期限</Typography>
                <Typography>{reservation.depositDate}</Typography>
              </Box>
            </Card>
            <Box>
              <Typography variant="subtitle1" sx={{ fontSize: '15px' }}>
                決済方法
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography sx={{ fontSize: '18px' }}>窓口現金支払い</Typography>
              <Typography sx={{ fontSize: '18px' }}>アクセス方法を確認</Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  resetReservationState();
                  navigate(`/c001/arealist?facilityId=${facility.facilityId}`);
                }}
              >
                ホームへ戻る
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PageBase>
  );
};

export default TemporaryReservationCompletePage;
